import type { FC } from 'react';
import { useCallback } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { updateDeviationEntity } from '@wix/da-shared-react/pkg/redux/deviations/actionCreators';
import { updateCommission } from '@wix/da-shared-react/pkg/redux/commissions/actionCreators';
import { dollarsToPoints } from '@wix/da-shared-react/pkg/utils/points';
import InlinePriceEdit from '../InlinePriceEdit';

interface Props {
  deviation: PapiDeviation;
}

const CommissionPriceEdit: FC<Props> = ({ deviation }) => {
  const dispatchUpdateDeviationEntity = useAction(updateDeviationEntity);
  const dispatchUpdateCommission = useAction(updateCommission);
  const onPriceUpdate = useCallback(
    (dollarPrice: number, onSuccess, onError) => {
      const pointsCost = dollarsToPoints(dollarPrice);
      dispatchUpdateCommission({
        commissionid: deviation.deviationId,
        pointsCost,
        redirectOnSuccess: false,
        onSuccess: (updatedDeviation: PapiDeviation) => {
          dispatchUpdateDeviationEntity(updatedDeviation);
          onSuccess && onSuccess();
        },
        onError,
      });
    },
    [deviation, dispatchUpdateCommission, dispatchUpdateDeviationEntity]
  );
  const dollarPrice = parseFloat(deviation.commission?.dollarsCost ?? '0');

  return <InlinePriceEdit currentValue={dollarPrice} onSave={onPriceUpdate} />;
};
CommissionPriceEdit.displayName = 'CommissionPriceEdit';

export default CommissionPriceEdit;
